import qs from 'qs';

export const getSuccessUrl = (search) => {
    const query = qs.parse(search, {ignoreQueryPrefix: true});
    return query.redirect || '/bi/kpis';
};
